import axios from 'axios';
import { isANumber } from '../../helpers/helperFunctions';

export const getRootTeamMemberAsync = async (id) => {
  const baseUrl = `/user/team?levelCount=4`;
  const url = id ? `${baseUrl}&userId=${id}` : baseUrl;

  return await axios.get(url);
};

export const getRootTeamMemberTradingAsync = async (id) => {
  const baseUrl = `/trading/structure?levelCount=4`;
  const url = id ? `${baseUrl}&userId=${id}` : baseUrl;

  return await axios.get(url);
};

export const getBottomTeamMemberAsync = async (position, levelCount = 4) => {
  return await axios.get(
    `/user/team/bottom?levelCount=${levelCount}&leg=${position}`
  );
};

export const getBottomTeamMemberTradingAsync = async (
  position,
  levelCount = 4
) => {
  return await axios.get(
    `/trading/structure/bottom?levelCount=${levelCount}&leg=${position}`
  );
};

export const searchTeamMembersAsync = async ({ searchTerm }) => {
  let url = '';
  if (isNaN(searchTerm)) {
    url = `/user/team/search?username=${searchTerm}`;
  } else {
    url = `/user/team/search?userId=${searchTerm}`;
  }

  return await axios.get(url);
};

export const getDirectMembersAsync = async (id, countPerPage) => {
  const baseUrl = `/user/team/direct`;
  const url = id ? `${baseUrl}?userId=${id}` : baseUrl;

  return await axios.get(url, {
    params: {
      countPerPage
    }
  });
};

export const getDirectTeamLegUsersAsync = async (
  id,
  numberOfPage,
  countPerPage,
  leg
) => {
  const baseUrl = `/user/team/direct/leg`;
  const url = id ? `${baseUrl}?userId=${id}` : baseUrl;

  return await axios.get(url, {
    params: {
      numberOfPage,
      countPerPage,
      leg
    }
  });
};

export const getLevelsAsync = async () => {
  return await axios.get(`/user/team/levels`);
};

export const getVolumesAsync = async () => {
  return await axios.get(`/user/team/volume`);
};

// export const getCustomersAsync = async () => {
//   const url = `/user/team/customer/info`;

//   return await axios.get(url);
// };

export const getCustomersPersonalAsync = async (
  numberOfPage,
  countPerPage,
  keyword
) => {
  const url = `/user/team/customer/personal`;

  const data = isANumber(keyword);

  return await axios.get(url, {
    params: keyword
      ? data
        ? {
            userId: parseInt(keyword),
            numberOfPage,
            countPerPage
          }
        : {
            keyword,
            numberOfPage,
            countPerPage
          }
      : {
          numberOfPage,
          countPerPage
        }
  });
};

export const getCustomersTeamAsync = async (
  numberOfPage,
  countPerPage,
  keyword
) => {
  const url = `/user/team/customer/team`;

  const data = isANumber(keyword);

  return await axios.get(url, {
    params: keyword
      ? data
        ? {
            userId: parseInt(keyword),
            numberOfPage,
            countPerPage
          }
        : {
            keyword,
            numberOfPage,
            countPerPage
          }
      : {
          numberOfPage,
          countPerPage
        }
  });
};

export const getCustomersOrderAsync = async (
  numberOfPage,
  countPerPage,
  keyword
) => {
  const url = `/user/team/customer/order`;

  const data = isANumber(keyword);

  return await axios.get(url, {
    params: keyword
      ? data
        ? {
            id: parseInt(keyword),
            numberOfPage,
            countPerPage
          }
        : {
            keyword,
            numberOfPage,
            countPerPage
          }
      : {
          numberOfPage,
          countPerPage
        }
  });
};

export const getCustomerDetailsAsync = async (id) => {
  const url = `/user/team/customer/user/${id}`;

  return await axios.get(url);
};

export const getCustomerOrderDetailsAsync = async (userOrderId) => {
  const url = `/user/team/customer/order/${userOrderId}/details`;

  return await axios.get(url);
};

export const unilevelAsync = async () => {
  const url = `/user/team/unilevel`;
  return await axios.get(url);
};
